import { applyMiddleware, compose, createStore } from "redux";

import createSagaMiddleware from "redux-saga";
import reducers from "./redux";
import sagas from "./middleware";

const exportFunction = function (initialState = {}) {
  const composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;
  const sagaMiddleware = createSagaMiddleware();
  const enchancer = composeEnhancers(applyMiddleware(sagaMiddleware));
  const reduxStore = createStore(reducers, initialState, enchancer);
  sagaMiddleware.run(sagas);
  return reduxStore;
};

export default exportFunction;
